module.exports = __webpack_public_path__ + "img/raffle-pointer.8bb17c09.png";